<template>
    <div :class="['totem-tag', size, {'-clear-all': clearAll}]" @click="onClick">
        <span class="totem-tag__label" v-if="label">{{ label }}</span>
        <span class="totem-tag__name">{{ name }}</span>
        <span class="totem-tag__count" v-if="count">({{ count }})</span>
        <button class="icon-cancel" v-if="clear && !clearAll" @click="handleClick"></button>
    </div>
</template>

<script>
    export default {
        props: {
            name: String,
            label: String,
            count: Number,
            size: {
                type: String,
                validator: (prop) => [ 'small', 'large' ].includes(prop),
                default: 'small'

            },
            clear: {
                type: Boolean,
                default: true
            },
            clearAll: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleClick (e) {
                this.$emit('handleClick', this.content)
            },
            onClick (e) {
                if (this.clearAll) {
                    this.handleClick(e)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .totem-tag {
        font-family: PlusJakartaSans-Regular, sans-serif;
        display: flex;
        margin: 5px 10px 5px 0;
        position: relative;
        align-self: flex-start;
        color: $tuatara;
        background: $medium_blue;
        align-items: center;
        justify-content: center;

        &__name {
            white-space: nowrap;
        }

        &__label {
            font-family: PlusJakartaSans-Medium, sans-serif;
            white-space: nowrap;
            margin-right: 5px;
            &:after {
                content: ':'
            }
        }

        &__count {
            padding-left: 5px;
        }

        &.small {
            font-size: 1.4rem;
            border-radius: 16px;
            padding: 4px 14px;
            min-height: 26px;
            border: none;

            .icon-clear {
                color: $tuatara;
                right: 0;
            }

            &.-clear-all {
                text-transform: uppercase;
                cursor: pointer;
                padding: 7px 14px;
            }
        }

        .icon-cancel {
            font-size: 2rem;
            border: none;
            background: transparent;
            color: $tuatara;
        }

        &.fi-authorizations {
            text-transform: uppercase;
        }
    }
</style>
